import axios from 'client';
import * as dto from 'client/dto';

function getMetadata(): Promise<dto.ApplicationMetadataModel> {
  return axios
    .get(`/api/app/metadata`, {
      headers: {
        'X-Entity-Type': 'Metadata',
      },
    })
    .then(({ data }) => data);
}

export default {
  getMetadata,
};
